import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@deal/components'
import { lowerCase } from 'lodash'
import { DepartmentContext } from '#src/context/department'
import AuthenticationFlowViewLayout from '#src/components/AuthenticationFlow/components/AuthenticationFlowViewLayout'
import List from '#src/routes/curations/main/components/List'
import { generateCreateUrlFromCategory } from '#src/services/path'
import { AuthenticationFlowViewLayoutProps } from '#src/components/AuthenticationFlow'
import styles from './styles.css'

const RegisterViaPath: React.FC<AuthenticationFlowViewLayoutProps> = ({ standalone }) => {
  const { department } = useContext(DepartmentContext)

  return (
    <>
      <AuthenticationFlowViewLayout standalone={standalone}>
        <div className={styles.header}>{`Sign up for Curated and work with a real ${lowerCase(
          department?.displayName
        ) || ''} expert who will`}</div>
        <List departmentType={department?.type} />
        <Link
          to={generateCreateUrlFromCategory({
            maybeCategorySlug: department ? department?.slug : null,
            sourceKey: 'register-via-path',
            pathIntent: 'register'
          })}
        >
          <Button variant="primary" className={styles.submitButton} type="submit">
            Get started
          </Button>
        </Link>
      </AuthenticationFlowViewLayout>
    </>
  )
}

export default RegisterViaPath
